import { Brand } from '../types/catalog';

// Datos de demostración. Las condiciones NO están verificadas: deben cargarse y
// verificarse desde el panel de administración antes de publicarse como oferta.
export const brands: Brand[] = [
  {
    id: 'toyota',
    name: 'Toyota',
    slug: 'toyota',
    tagline: 'SUV, sedanes y pick-ups para cada camino.',
    defaultOffer: {
      tna: 48,
      cft: null,
      amortization: 'frances',
      terms: [12, 24, 36, 48],
      minDownPct: 40,
      maxFinanceAmount: 30000000,
      monthlyInsurance: null,
      adminFees: null,
      taxNote: 'IVA sobre intereses incluido en la cuota. Sellos según jurisdicción.',
      lender: 'Entidad financiera a confirmar',
      promo: null,
      validUntil: '2026-11-30',
      conditions: 'Sujeto a aprobación crediticia de la entidad otorgante.',
      verified: false,
      updatedAt: '2026-10-05T10:00:00.000Z',
    },
  },
  {
    id: 'volkswagen',
    name: 'Volkswagen',
    slug: 'volkswagen',
    tagline: 'Hatchbacks y SUV con tecnología alemana.',
    defaultOffer: {
      tna: 52,
      cft: null,
      amortization: 'frances',
      terms: [12, 18, 24, 36],
      minDownPct: 35,
      maxFinanceAmount: 25000000,
      monthlyInsurance: null,
      adminFees: null,
      taxNote: 'IVA sobre intereses incluido en la cuota.',
      lender: 'Entidad financiera a confirmar',
      promo: null,
      validUntil: '2026-11-15',
      conditions: 'Sujeto a aprobación crediticia de la entidad otorgante.',
      verified: false,
      updatedAt: '2026-10-05T10:00:00.000Z',
    },
  },
  {
    id: 'chevrolet',
    name: 'Chevrolet',
    slug: 'chevrolet',
    tagline: 'Conectividad y eficiencia para el día a día.',
    defaultOffer: {
      tna: 55,
      cft: null,
      amortization: 'aleman',
      terms: [12, 24, 36],
      minDownPct: 30,
      maxFinanceAmount: 22000000,
      monthlyInsurance: null,
      adminFees: null,
      taxNote: 'IVA sobre intereses incluido en la cuota.',
      lender: 'Entidad financiera a confirmar',
      promo: null,
      validUntil: '2026-11-30',
      conditions: 'Sujeto a aprobación crediticia de la entidad otorgante.',
      verified: false,
      updatedAt: '2026-10-05T10:00:00.000Z',
    },
  },
  {
    id: 'renault',
    name: 'Renault',
    slug: 'renault',
    tagline: 'Diseño y versatilidad en cada segmento.',
    defaultOffer: {
      tna: 50,
      cft: null,
      amortization: 'frances',
      terms: [12, 24, 36, 48],
      minDownPct: 30,
      maxFinanceAmount: 20000000,
      monthlyInsurance: null,
      adminFees: null,
      taxNote: 'IVA sobre intereses incluido en la cuota.',
      lender: 'Entidad financiera a confirmar',
      promo: null,
      validUntil: '2026-12-15',
      conditions: 'Sujeto a aprobación crediticia de la entidad otorgante.',
      verified: false,
      updatedAt: '2026-10-05T10:00:00.000Z',
    },
  },
  {
    id: 'fiat',
    name: 'Fiat',
    slug: 'fiat',
    tagline: 'Sedanes y pick-ups pensados para Argentina.',
    defaultOffer: {
      tna: 46,
      cft: null,
      amortization: 'frances',
      terms: [12, 24, 36, 48, 60],
      minDownPct: 30,
      maxFinanceAmount: 20000000,
      monthlyInsurance: null,
      adminFees: null,
      taxNote: 'IVA sobre intereses incluido en la cuota.',
      lender: 'Entidad financiera a confirmar',
      promo: null,
      validUntil: '2026-11-30',
      conditions: 'Sujeto a aprobación crediticia de la entidad otorgante.',
      verified: false,
      updatedAt: '2026-10-05T10:00:00.000Z',
    },
  },
  {
    id: 'ford',
    name: 'Ford',
    slug: 'ford',
    tagline: 'Pick-ups y SUV con carácter.',
    defaultOffer: {
      tna: null,
      cft: null,
      amortization: 'frances',
      terms: [12, 24, 36],
      minDownPct: 40,
      maxFinanceAmount: null,
      monthlyInsurance: null,
      adminFees: null,
      taxNote: '',
      lender: 'Entidad financiera a confirmar',
      promo: null,
      validUntil: '2026-12-31',
      conditions: 'Condiciones a cargar desde el panel.',
      verified: false,
      updatedAt: '2026-10-12T10:00:00.000Z',
    },
  },
  {
    id: 'jeep',
    name: 'Jeep',
    slug: 'jeep',
    tagline: 'SUV con espíritu aventurero.',
    defaultOffer: {
      tna: null,
      cft: null,
      amortization: 'frances',
      terms: [12, 24, 36],
      minDownPct: 40,
      maxFinanceAmount: null,
      monthlyInsurance: null,
      adminFees: null,
      taxNote: '',
      lender: 'Entidad financiera a confirmar',
      promo: null,
      validUntil: '2026-12-31',
      conditions: 'Condiciones a cargar desde el panel.',
      verified: false,
      updatedAt: '2026-10-12T10:00:00.000Z',
    },
  },
  {
    id: 'baic',
    name: 'BAIC',
    slug: 'baic',
    tagline: 'SUV con tecnología y equipamiento.',
    defaultOffer: {
      tna: null,
      cft: null,
      amortization: 'frances',
      terms: [12, 24, 36],
      minDownPct: 40,
      maxFinanceAmount: null,
      monthlyInsurance: null,
      adminFees: null,
      taxNote: '',
      lender: 'Entidad financiera a confirmar',
      promo: null,
      validUntil: '2026-12-31',
      conditions: 'Condiciones a cargar desde el panel.',
      verified: false,
      updatedAt: '2026-10-12T10:00:00.000Z',
    },
  },
  {
    id: 'peugeot',
    name: 'Peugeot',
    slug: 'peugeot',
    tagline: 'Diseño francés para cada día.',
    defaultOffer: {
      tna: null,
      cft: null,
      amortization: 'frances',
      terms: [12, 24, 36],
      minDownPct: 40,
      maxFinanceAmount: null,
      monthlyInsurance: null,
      adminFees: null,
      taxNote: '',
      lender: 'Entidad financiera a confirmar',
      promo: null,
      validUntil: '2026-12-31',
      conditions: 'Condiciones a cargar desde el panel.',
      verified: false,
      updatedAt: '2026-10-12T10:00:00.000Z',
    },
  },
  {
    id: 'ram',
    name: 'Ram',
    slug: 'ram',
    tagline: 'Pick-ups con fuerza para el trabajo y la ruta.',
    defaultOffer: {
      tna: null,
      cft: null,
      amortization: 'frances',
      terms: [12, 24, 36],
      minDownPct: 40,
      maxFinanceAmount: null,
      monthlyInsurance: null,
      adminFees: null,
      taxNote: '',
      lender: 'Entidad financiera a confirmar',
      promo: null,
      validUntil: '2026-12-31',
      conditions: 'Condiciones a cargar desde el panel.',
      verified: false,
      updatedAt: '2026-10-14T10:00:00.000Z',
    },
  },
  {
    id: 'citroen',
    name: 'Citroën',
    slug: 'citroen',
    tagline: 'Confort y practicidad para la ciudad y el trabajo.',
    defaultOffer: {
      tna: null,
      cft: null,
      amortization: 'frances',
      terms: [12, 24, 36],
      minDownPct: 40,
      maxFinanceAmount: null,
      monthlyInsurance: null,
      adminFees: null,
      taxNote: '',
      lender: 'Entidad financiera a confirmar',
      promo: null,
      validUntil: '2026-12-31',
      conditions: 'Condiciones a cargar desde el panel.',
      verified: false,
      updatedAt: '2026-10-14T10:00:00.000Z',
    },
  },
];
